var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-button',{attrs:{"id":'AttachButton' + _vm._uid,"loading":_vm.uploading,"type":"primary","icon":"import"}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }